import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { langMatcher, notfoundMatcher } from './share/entity/html-suffix-url-matcher';


const routes: Routes = [
  { matcher: notfoundMatcher, loadChildren: () => import('./not-found/not-found.module').then(mod => mod.NotFoundModule) },
  { matcher: langMatcher, loadChildren: () => import('./web-generator/template-generator/template-generator.module').then(mod => mod.TemplateGeneratorModule) },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
